import { render, staticRenderFns } from "./clientInfluencers.vue?vue&type=template&id=06b1bac1&"
import script from "./clientInfluencers.vue?vue&type=script&lang=js&"
export * from "./clientInfluencers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports